import { styled } from '@mui/material/styles'
import SideMenu from 'components/SideMenu'
import { sidebarWidth } from 'config'

const SideContainer = styled('aside')(({ theme }) => ({
  position: 'fixed',
  paddingTop: 85,
  width: sidebarWidth,
  height: '100%',
  backgroundColor: theme.palette.grey[100],
}))

const SideBar = () => {
  return (
    <SideContainer>
      <SideMenu />
    </SideContainer>
  )
}

export default SideBar
